module.exports = __webpack_public_path__ + "img/icon_setup_blue14.177358f0.svg";